<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M10.25 3.53365C9.5737 3.19228 8.80931 3 8 3C5.23858 3 3 5.23858 3 8C3 8.5226 3.08018 9.02648 3.2289 9.5M5.75 12.4664C6.4263 12.8077 7.19069 13 8 13C10.7614 13 13 10.7614 13 8C13 7.4774 12.9198 6.97352 12.7711 6.5"
        stroke="var(--bg-color)" stroke-width="2" />
    <path d="M12.8317 5.02352L7.73238 5.02352L10.282 0.607407L12.8317 5.02352Z" fill="var(--bg-color)" />
    <path d="M3.24317 11.1656L8.0131 11.1656L5.62814 15.2965L3.24317 11.1656Z" fill="var(--bg-color)" />
</svg>
